import { gql } from '@apollo/client';

export const fetchSupportIssuesForEntitlement = gql`
  query fetchSupportIssuesForEntitlement(
    $id: String
    $searchOptions: ConnectionSearchOptions
    $searchParam: SupportIssueEntitlementSearchParams
  ) {
    entitlementDetails(id: $id) {
      id
      entitlementNumber
      supportIssues(searchOptions: $searchOptions, searchParam: $searchParam) {
        totalHits
        results {
          id
          issueKey
          summary
          currentStatus
          reporterEmailAddress
          updatedTimestamp
        }
      }
    }
  }
`;
